import React from "react";
import Paper from "material-ui/Paper";

export default () => (
  <div>
    <Paper className={"paper-container"}>
      <div>
        <h1>404 - Not found</h1>
      </div>
    </Paper>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/404.js